<template>
  <b-modal
    id="availability-zones-dialog"
    ref="modal"
    :title="$t('vehicles.availability')"
    :ok-disabled="formOpened"
    :cancel-disabled="formOpened"
    :hide-header-close="formOpened"
    :no-close-on-backdrop="formOpened"
    :no-close-on-esc="formOpened"
    size="lg"
    centered
  >
    <b-card v-if="formOpened" :header="formHeader">
      <zones-form
        :id="editId"
        :vehicle-id="vehicleId"
        :api-interface="api"
        @saved="onSaved"
        @cancel="closeForm"
      />
    </b-card>

    <div v-if="!formOpened">
      <b-button variant="light" class="mb-2" @click="onAdd">
        {{ $t('general.add_new') }}
      </b-button>

      <div class="display-inline-block float-right">
        <switcher-field
          :checked="availableEverywhere"
          @change="availabilityChanged"
          >{{
            $t('vehicles.attributes.available_everywhere.label')
          }}</switcher-field
        >
      </div>
    </div>

    <zones-table ref="table" :api-builder="apiBuilder" @edit="onEdit" />
  </b-modal>
</template>

<script>
import ZonesForm from './Form'
import ZonesTable from './Table'
import Api from './Api'
import SwitcherField from '../../components/Switcher'

export default {
  name: 'AvailabilityZones',

  components: {
    ZonesForm,
    ZonesTable,
    SwitcherField,
  },

  props: {
    vehicleId: { type: [Number, String], required: true },
    availableEverywhere: { type: Boolean, default: true },
  },

  data: () => ({
    formOpened: false,
    editId: null,
  }),

  computed: {
    formHeader() {
      return this.editId === null
        ? this.$t('general.add_new')
        : this.$t('general.edit')
    },
    api() {
      return new Api(this.vehicleId)
    },
  },

  methods: {
    apiBuilder() {
      return this.api
    },
    onSaved() {
      this.$refs.table.refresh()
      this.closeForm()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
    onEdit(item) {
      this.editId = item.id
      this.formOpened = true
    },
    onAdd() {
      this.formOpened = true
      this.editId = null
    },
    closeForm() {
      this.editId = null
      this.formOpened = false
    },
    availabilityChanged() {
      this.$emit('changed')
    },
  },
}
</script>
